module.exports = __webpack_public_path__ + "img/default3.986592cb.jpg";